import axios from "axios";
import { cmsHeaders, headers } from "../exports/exports";

export const fetchHomeSliders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-sliders?sort=Order%3Aasc&populate=*`,
      { headers },
    );
    return response.data.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchTilesHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/home-info-tile-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeTiles = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/home-info-tile?sort=sort_order:asc`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeAbout = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/home-about`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeMessage = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/home-chairman-s-message`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchChooseUs = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/home-why-choose-us`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

// export const fetchHomeHighlights = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_cmsUrl}/content-manager/home-highlights`,
//       { headers: cmsHeaders },
//     );
//     return response.data.slice(-1);
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

export const fetchHomeHighlights = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-highlights?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeCount = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-count-sections?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeFacultyHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-faculty-headers?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeFacultyList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-faculty-lists?populate=*`,
      { headers },
    );
    return response.data.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeTestimonialHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-testimonial-headers?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeTestimonial = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-home-testimonials?populate=*`,
      { headers },
    );
    return response.data.data;
  } catch (error) {
    console.error("Server Error");
  }
};
